<template>
  <div :id="job.id" class="list-box-container"
       @mouseup="($_can('jobs.show') ||
         $_can('jobs.view-own'))"
       :class="[
         job.arrival_window_period === 'pm' && job.cash_collected !== false ? 'pm-job' : '',
         canShowCashCollect && job.cash_collected === false && 'job-not-cash-collected'
       ]"
  >
    <template v-if="jobLoading">
      <div class="lds-ellipsis px-4 py-4">
        <div />
        <div />
        <div />
      </div>
    </template>
    <template v-else>
      <router-link class="job-block-font" :to="{ name: 'JobsEdit', params: { id: `${job.id}`}, query: { q: `${q ? `${encodeURIComponent(q.toUpperCase())}` : ''}` }}">
        <div class="d-flex list-box-header col-12">
          <div class="list-box-header-left col-xl-5 col-lg-4 col-md-5 col-4">
            <div class="pl-0 d-flex align-items-center col-xl-7 col-lg-10 col-md-12 col-6 pointer">
              <div class="col-md-4 list-box-status align-items-start pl-0" @mouseover="visible = true" @mouseout="visible = false">
                <div class="pointer d-flex">
                  <span class="ref-id position-relative pr-2">
                    <img
                      class="flat-rate-indicator"
                      v-if="job.is_flat_rate"
                      src="../../assets/img/flat-rate-job-icon.svg"
                      alt="Flat rate job icon"
                    />
                    {{ job.ref_id }}
                  </span>
                  <span>
                    <i
                      v-if="visible"
                      class="fa fa-copy list-box-icon pointer"
                      @click.stop.prevent="copyToClipboard(job.ref_id, 'Successfully copied to clipboard')"
                      @mousemove="visible = true"
                    />
                  </span>
                </div>
                <template v-if="job.status">
                  <div class="d-flex align-items-center">
                    <span v-if="job.status === 'Accepted'" :class="'btn-status btn-active'"><span v-if="job.status.name">{{ job.status.name }}</span><span v-else>{{ job.status }}</span></span>
                    <span v-else-if="job.status === 'On Hold'" :class="'btn-status btn-rejected'"><span v-if="job.status.name">{{ job.status.name }}</span><span v-else>{{ job.status }}</span></span>
                    <span v-else-if="job.status === 'Pending'" :class="'btn-status btn-pending'"><span v-if="job.status.name">{{ job.status.name }}</span><span v-else>{{ job.status }}</span></span>
                    <span v-else-if="job.status === 'Created'" :class="'btn-status btn-created'"><span v-if="job.status.name">{{ job.status.name }}</span><span v-else>{{ job.status }}</span></span>
                    <span v-else-if="job.status === 'Canceled'" :class="'btn-status btn-cancelled'"><span v-if="job.status.name">{{ job.status.name }}</span><span v-else>{{ job.status }}</span></span>
                    <span v-else-if="job.status === 'Tracking done'" :class="'btn-status btn-inprogress'"><span v-if="job.status.name">{{ job.status.name }}</span><span v-else>{{ job.status }}</span></span>
                    <span v-else-if="job.status === 'Collect payment'" :class="'btn-status btn-inprogress'"><span v-if="job.status.name">{{ job.status.name }}</span><span v-else>{{ job.status }}</span></span>
                    <span v-else-if="job.status === 'In Progress'" :class="'btn-status btn-inprogress'"><span v-if="job.status.name">{{ job.status.name }}</span><span v-else>{{ job.status }}</span></span>
                    <span v-else-if="job.status === 'Completed'" :class="'btn-status btn-completed'"><span v-if="job.status.name">{{ job.status.name }}</span><span v-else>{{ job.status }}</span></span>
                    <span v-else-if="job.status === 'Rejected'" :class="'btn-status btn-rejected'"><span v-if="job.status.name">{{ job.status.name }}</span><span v-else>{{ job.status }}</span></span>
                    <span v-else :class="'btn-status btn-pending'"><span v-if="job.status.name">{{ job.status.name }}</span><span v-else>{{ job.status }}</span></span>
                  </div>
                </template>
              </div>
              <div class="job-customer col-9 pl-5 d-none d-md-block">
                <div class="d-flex align-items-center">
                  <span>{{ job.customer }}</span>
                  <span v-if="job.has_subscription" class="ml-2 mod-icon-membership d-inline-block" style="min-width: 20px" />
                  <span v-if="job.recurly_subscription_id" class="ml-2 mod-icon-recurly-subscription d-inline-block" style="min-width: 20px" />
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center pl-0 col-2 wrap pointer responsive-handle laptop-hidden d-lg-none d-xl-flex">
              <div>
                {{ job.carrier_name ? job.carrier_name : '-' }}
              </div>
            </div>
            <label class="responsive-handle laptop-hidden" />
            <div class="d-flex align-items-center col-2 wrap pointer responsive-handle laptop-hidden">
              <customTooltip :config="{ placement: 'top' }">
                <div
                  slot-scope="{ isOpen, open, close }"
                  @mouseover="open"
                  @mouseleave="close"
                >
                  <span data-trigger>
                    {{ job.move_date }}
                  </span>
                  <div
                    v-show="isOpen"
                    data-popper
                    class="custom-tooltip"
                  >
                    <div
                      x-arrow
                      class="border-black"
                    />
                    Move date
                  </div>
                </div>
              </customTooltip>
            </div>
            <div class="d-flex align-items-center col-2 wrap pointer responsive-handle laptop-hidden ml-1 d-md-none d-xl-flex">
              <div class="text-nowrap">
                {{ job.move_size }}
              </div>
            </div>
          </div>
          <div class="list-box-header-right col-sm-6 col-xl-6 col-lg-6 col-md-4 col-5">
            <div class="cluster-user-username responsive-hidden d-flex align-items-center col-0 col-md-0 col-lg-7 col-xl-8 wrap pointer">
              <div class="col-4">
                <span class="mr-3" v-if="job.arrival_window_from || job.arrival_window_to">
                  {{ formatTime(job.arrival_window_from) }} - {{ formatTime(job.arrival_window_to) }}
                </span>
              </div>

              <div class="col-3 d-flex align-items-center justify-content-center">
                {{ job.source ? job.source.name : '' }}
              </div>

              <div class="col-5 d-flex align-items-center justify-content-start flex-wrap ml-3">
                <tag-color v-for="tag in job.tags" :key="tag.id" :color="tag.color.name" :name="tag.name" input-class="mr-1" />
              </div>
            </div>
            <div class="job-trucks-movers d-flex flex-column align-items-center pr-4 wrap pointer col-sm-2 col-xl-2 col-lg-2 col-md-3 col-5 d-md-flex">
              <div class="d-flex pl-1">
                <i class="fa fa-user list-box-icon" />
                <span class="price-value">
                  {{ job.movers }}
                </span>
              </div>
              <div class="d-flex mt-2">
                <i class="fa fa-truck list-box-icon" />
                <span class="price-value">
                  {{ job.trucks }}
                </span>
              </div>
            </div>
            <div class="d-flex align-items-center price wrap pointer col-sm-5 col-7 col-md-2 col-lg-2 col-xl-3 mobile-padding-reset">
              <span class="pl-2" v-if="job.is_flat_rate">${{ job.price }}</span>
              <span class="pl-2" v-if="!job.is_flat_rate && job.price_per_hour">${{ job.price_per_hour }}</span>
            </div>
          </div>
          <div class="pl-1 pr-md-0 pr-lg-4 ml-md-5 ml-lg-4 options col-3 col-sm-2 col-md-2 col-xl-1 d-flex justify-content-end">
            <div class="pl-3 pr-md-0 pr-xl-3 options-buttons d-flex justify-content-end">
              <div class="dropdown" @click.prevent>
                <button type="button" class="btn btn-secondary add-filter" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false"
                />
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                  <template v-if="canShowCashCollect && job.cash_collected !== null && $_can('jobs.set-cash-collected')">
                    <button class="dropdown-item nav-link btn" @click="cashCollectModal = true">
                      <template v-if="!job.cash_collected">
                        Cash collect
                      </template>
                      <template v-else>
                        Cash not collected
                      </template>
                    </button>
                  </template>
                  <template v-if="job.status_id !== 16">
                    <template v-if="!job.carrier_name || job.status_id === 31">
                      <button class="dropdown-item nav-link btn" @click="reassignCarrierModal"
                              v-if="$_can('jobs.carrier.assign')"
                      >
                        Assign carrier
                      </button>
                      <button class="dropdown-item nav-link btn" @click="showModalCancelJob = true"
                              v-if="job.status_id !== 30 && $_can('jobs.status.update')"
                      >
                        Cancel
                      </button>
                    </template>
                    <template v-else>
                      <template v-if="job.status_id === 2">
                        <button class="dropdown-item nav-link btn" @click="showModalAcceptJob = true"
                                v-if="job.status_id !== 31 && $_can('jobs.status.update')"
                        >
                          Accept
                        </button>
                        <button class="dropdown-item nav-link btn" @click="showModalRejectJob = true"
                                v-if="job.status_id !== 31 && $_can('jobs.status.update')"
                        >
                          Reject
                        </button>
                        <button class="dropdown-item nav-link btn" @click="showModalCancelJob = true"
                                v-if="job.status_id !== 30 && $_can('jobs.status.update')"
                        >
                          Cancel
                        </button>
                      </template>
                      <template v-if="job.status_id === 3">
                        <button class="dropdown-item nav-link btn" v-if="$_can('jobs.status.update')"
                                @click="changeStatus(job.id, 40)"
                        >
                          In progress
                        </button>
                        <button class="dropdown-item nav-link btn" @click="showModalIsSmallJob = true">
                          Change job size
                        </button>
                        <button class="dropdown-item nav-link btn" @click="showModalCancelJob = true"
                                v-if="job.status_id !== 30 && $_can('jobs.status.update')"
                        >
                          Cancel
                        </button>
                      </template>
                    </template>
                    <button class="dropdown-item nav-link btn"
                            @click="changeStatus(job.id, 21)"
                            v-if="(job.status_id === 1 ||
                              job.status_id === 2 ||
                              job.status_id === 3 ||
                              job.status_id === 31) &&
                              job.status_id !== 21 &&
                              $_can('jobs.status.update')"
                    >
                      On Hold
                    </button>
                    <button class="dropdown-item nav-link btn" @click="restoreStatus()"
                            v-if="(job.status_id === 30 || job.status_id === 21) && $_can('jobs.status.update')"
                    >
                      Restore
                    </button>
                    <button class="dropdown-item nav-link btn" @click="reassignUserModal"
                            v-if="$_can('jobs.assign')"
                    >
                      Assign user
                    </button>
                    <button class="dropdown-item nav-link btn" @click="reassignCarrierModal"
                            v-if="$_can('jobs.carrier.assign') && job.status_id !== 16 && job.status_id !== 30 && job.status_id !== 31 && job.carrier_name"
                    >
                      Assign carrier
                    </button>
                    <button class="dropdown-item nav-link btn" @click="changeStatus(job.id, 2)"
                            v-if="job.status_id === 31 && $_can('jobs.status.update')"
                    >
                      Return To Pending
                    </button>
                  </template>
                  <!--                  <button class="dropdown-item nav-link btn" @click="sendContractEmail"
                          v-if="$_can('jobs.status.update')"
                  >
                    Send pre-agreement
                  </button>-->
                </div>
              </div>
              <button class="btn btn-secondary expand-jobs mobile-hidden" @click.prevent.stop="toggleJob(job.id)">
                <i class="fa fa-caret-down caret" :class="{ rotate: expanded.includes(job.id) }" />
              </button>
            </div>
          </div>
        </div>
      </router-link>
      <hr :class="[expanded.includes(job.id) ? 'w-100 divider' : 'hidden']" />
      <div class="d-flex flex-column job-block-font" :class="[expanded.includes(job.id) ? 'list-box-expanded' : 'hidden']">
        <div class="d-flex col-12 p-0">
          <div class="col-lg-6 col-md-5 d-flex">
            <div class="contact-info-wrapper d-flex flex-column justify-content-start col-lg-5 col-0 pl-0 pr-0" v-if="showCustomerInfo && job.customer_email">
              <div class="contact-info mb-4">
                <span class="job-heading pb-3">
                  Contact info
                </span>
                <span class="email">
                  <i class="fa fa-at list-box-icon" />
                  {{ job.customer_email }}
                </span>
                <span class="phone" v-if="job.customer_phone">
                  <i class="fa fa-phone list-box-icon" />
                  {{ phoneMask.maskedPhone(job.customer_phone.replace('+1', '')) }}
                </span>
              </div>
            </div>
            <div class="d-flex flex-column justify-content-start col-lg-7 col-md-12 col-12 pl-0">
              <span class="job-heading" style="font-size: 1rem">
                {{ job.customer }}
              </span>
              <div class="circles-wrap" v-if="!showAllAddresses">
                <div class="d-flex flex-column justify-content-between mt-3">
                  <div class="d-flex mb-25px">
                    <i
                      class="fa fa-circle c-pickup"
                      :class="[
                        job.addresses[0].type.name === 'Pickup'
                          ? 'c-pickup'
                          : 'c-delivery d-flex align-items-center',
                      ]"
                    />
                    <span class="d-flex flex-column address-text">
                      {{ job.addresses[0].full_address }}
                      <div class="d-flex align-items-center pt-3">
                        <span class="apt-floor">Apt: {{ job.addresses[0].apartment ? job.addresses[0].apartment : '-' }}</span>
                        <span class="apt-floor pl-4">Floor: {{ job.addresses[0].floor ? job.addresses[0].floor : '-' }}</span>
                      </div>
                    </span>
                  </div>
                </div>
                <span @click="showAllAddresses = !showAllAddresses" data-trigger class="remaining-addresses" v-if="job.addresses.length > 2">
                  {{ parseInt(job.addresses.length) - 2 }}
                </span>
                <div class="d-flex flex-column justify-content-between mt-3">
                  <div class="d-flex mb-4">
                    <i
                      class="fa fa-circle c-pickup"
                      :class="[
                        job.addresses[job.addresses.length - 1].type.name === 'Pickup'
                          ? 'c-pickup'
                          : 'c-delivery',
                        job.addresses[job.addresses.length - 1].apartment || job.addresses[job.addresses.length - 1].floor
                          ? 'fa-circle-with-apt'
                          : 'fa-circle'
                      ]"
                    />
                    <span class="d-flex flex-column address-text">
                      {{ job.addresses[job.addresses.length - 1].full_address }}
                      <div class="d-flex align-items-center pt-3">
                        <span class="apt-floor">Apt: {{ job.addresses[job.addresses.length - 1].apartment ? job.addresses[job.addresses.length - 1].apartment : '-' }}</span>
                        <span class="apt-floor pl-4">Floor: {{ job.addresses[job.addresses.length - 1].floor ? job.addresses[job.addresses.length - 1].floor : '-' }}</span>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
              <div class="circles-wrap" v-else>
                <div v-for="address in job.addresses" :key="address.id" class="d-flex flex-column justify-content-between" :class="{'mt-3': address.type.name === 'Pickup'}">
                  <div class="d-flex mb-25px">
                    <i
                      @click="showAllAddresses = !showAllAddresses"
                      class="fa fa-circle"
                      :class="[
                        address.type.name === 'Pickup'
                          ? 'c-pickup'
                          : 'c-delivery d-flex align-items-center',
                      ]"
                    />
                    <span class="d-flex flex-column address-text">
                      {{ address.full_address }}
                      <div class="d-flex align-items-center pt-3">
                        <span class="apt-floor">Apt: {{ address.apartment ? address.apartment : '-' }}</span>
                        <span class="apt-floor pl-4">Floor: {{ address.floor ? address.floor : '-' }}</span>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 d-flex pr-0">
            <div class="d-flex flex-column justify-content-start col-lg-5 responsive-handle">
              <div class="list-box-info mb-4">
                <div class="d-flex flex-wrap justify-content-between" style="gap: 10px">
                  <div class="d-flex flex-column">
                    <span class="job-heading pb-3">
                      Company
                    </span>
                    <span class="pb-3">
                      {{ job.company }}
                    </span>
                  </div>
                  <div>
                    <div class="d-flex flex-column">
                      <span class="job-heading pb-3">
                        Assigned to
                      </span>
                      <span class="pb-3">
                        <customTooltip :config="{ placement: 'top' }">
                          <div
                            slot-scope="{ isOpen, open, close }"
                            @mouseover="open"
                            @mouseleave="close"
                          >
                            <div v-if="job.username" data-trigger>
                              {{ job.username }}
                            </div>
                            <div v-else data-trigger class="d-flex">
                              <i class="fa fa-exclamation-circle unassigned-icon" />
                              <span class="ml-1">
                                Unassigned
                              </span>
                            </div>
                            <div
                              v-show="isOpen"
                              data-popper
                              class="custom-tooltip"
                            >
                              <div
                                x-arrow
                                class="border-black"
                              />
                              Assignee
                            </div>
                          </div>
                        </customTooltip>
                      </span>
                    </div>
                  </div>
                </div>


                <span class="job-heading pb-3">
                  Created at
                </span>
                <span class="pb-3">
                  {{ job.created_at }}
                </span>
              </div>
            </div>

            <div class="p-0 d-flex flex-column justify-content-start d-lg-none col-md-7 col-6 hidden-mobile">
              <template v-if="job.tags && job.tags.length > 0">
                <span class="job-heading pb-2">
                  Tags
                </span>
                <div class="d-flex align-items-center justify-content-start flex-wrap">
                  <tag-color v-for="tag in job.tags" :key="tag.id" :color="tag.color.name" :name="tag.name" input-class="mr-1" />
                </div>
              </template>
            </div>

            <div class="d-flex justify-content-end col-lg-4 col-md-4 col-2 responsive-handle">
              <div class="d-flex flex-column align-items-center">
                <button :disabled="canLeaveNote || !userHasAccessToCarrier"
                        class="btn btn-secondary pull-right"
                        @click="showModalCustomerNote = !showModalCustomerNote"
                >
                  <template v-if="job.customer_note">View note</template>
                  <template v-else>Add note</template>
                </button>
                <i class="fa text-secondary"
                   aria-hidden="true"
                   :class="showModalCustomerNote ? 'fa fa-caret-up' : 'fa fa-caret-down'"
                />
              </div>
              <customer-note v-if="showModalCustomerNote"
                             :customer-note="job.customer_note? job.customer_note.note : ''"
                             :model="'jobs'"
                             :model-id="job.id"
                             :note-id="job.customer_note ? job.customer_note.id : null"
                             :user-id="user.id"
                             :status-name="job.status"
                             @close="showModalCustomerNote = !showModalCustomerNote"
                             @ok="saveCustomerNote"
              />
              <error-field :errors="errors" field="customer" />
            </div>
            <div class="d-flex flex-column justify-content-start col-lg-3 col-md-5 col-12 pr-0">
              <div class=" md-flex flex-row justify-content-end list-box-info mb-4">
                <div class="small-job pr-3 pl-3" v-if="job.is_small">
                  <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.2288 4.66967L3.84519 10.7715V17.3571C3.84519 17.5276 3.91269 17.6911 4.03286 17.8117C4.15303 17.9323 4.31601 18 4.48595 18L8.9737 17.9883C9.14309 17.9875 9.30525 17.9194 9.42472 17.7989C9.5442 17.6784 9.61126 17.5154 9.61126 17.3454V13.4995C9.61126 13.329 9.67877 13.1655 9.79894 13.0449C9.9191 12.9243 10.0821 12.8566 10.252 12.8566H12.8151C12.985 12.8566 13.148 12.9243 13.2682 13.0449C13.3883 13.1655 13.4558 13.329 13.4558 13.4995V17.3426C13.4556 17.4272 13.472 17.511 13.504 17.5893C13.5361 17.6675 13.5833 17.7386 13.6428 17.7985C13.7023 17.8584 13.7731 17.906 13.8509 17.9384C13.9288 17.9708 14.0123 17.9875 14.0966 17.9875L18.5828 18C18.7527 18 18.9157 17.9323 19.0359 17.8117C19.156 17.6911 19.2235 17.5276 19.2235 17.3571V10.7671L11.8415 4.66967C11.7547 4.59948 11.6466 4.56121 11.5352 4.56121C11.4237 4.56121 11.3156 4.59948 11.2288 4.66967ZM22.8919 8.81697L19.5439 6.04795V0.482197C19.5439 0.35431 19.4933 0.231662 19.4032 0.141232C19.313 0.0508028 19.1908 0 19.0633 0H16.8207C16.6932 0 16.571 0.0508028 16.4808 0.141232C16.3907 0.231662 16.3401 0.35431 16.3401 0.482197V3.39989L12.7546 0.440004C12.4105 0.155902 11.9788 0.000567925 11.5332 0.000567925C11.0875 0.000567925 10.6558 0.155902 10.3117 0.440004L0.174407 8.81697C0.125744 8.85732 0.0854835 8.90691 0.0559251 8.96288C0.0263666 9.01886 0.00808995 9.08013 0.00213941 9.14319C-0.00381113 9.20626 0.00268106 9.26988 0.021245 9.33043C0.039809 9.39097 0.0700809 9.44726 0.110331 9.49606L1.13155 10.7417C1.17169 10.7907 1.22106 10.8313 1.27684 10.8611C1.33262 10.8909 1.39371 10.9093 1.45661 10.9154C1.51952 10.9215 1.583 10.9151 1.64342 10.8965C1.70385 10.878 1.76003 10.8476 1.80876 10.8072L11.2288 3.02217C11.3156 2.95198 11.4237 2.9137 11.5352 2.9137C11.6466 2.9137 11.7547 2.95198 11.8415 3.02217L21.262 10.8072C21.3106 10.8476 21.3667 10.878 21.427 10.8966C21.4874 10.9152 21.5508 10.9218 21.6136 10.9158C21.6765 10.9098 21.7376 10.8915 21.7933 10.8618C21.8491 10.8322 21.8985 10.7918 21.9388 10.7429L22.96 9.49726C23.0002 9.44818 23.0303 9.39161 23.0487 9.3308C23.067 9.26998 23.0732 9.20613 23.0669 9.14291C23.0606 9.0797 23.0418 9.01836 23.0118 8.96242C22.9818 8.90648 22.941 8.85705 22.8919 8.81697Z" fill="#FFAB00" />
                  </svg>
                </div>
                <div class="movers-number d-flex flex-column pl-2 pr-3">
                  <div class="movers btn-status mb-1" @click.self="showMoversTooltip(!showMovers.showTooltip)" :class="[
                    job.movers === job.assigned_movers.length ? 'turquoise-border-text' : 'orange-yellow-border-text',
                    job.assigned_movers.length === 0 ? 'red-border-text' : '',
                  ]"
                  >
                    <span v-if="job.assigned_movers.length" @click.self="showMoversTooltip(!showMovers.showTooltip)">
                      {{ job.assigned_movers.length }}/{{ job.movers }}

                      <div class="popover show-movers-popover" v-if="showMovers.showTooltip && job.assigned_movers">
                        <div class="w-100 d-flex align-items-center justify-content-end">
                          <span @click.self="hideMoversTooltip" class="mod-icon mod-icon-close" style="width: 10px; height: 10px" />
                        </div>
                        <div v-for="(mover, ind) in job.assigned_movers"
                             :key="mover.id"
                             class="d-flex justify-content-between align-items-center mb-1"
                        >
                          <div class="justify-content-center" :class="[ind+1 === job.assigned_movers.length ? 'd-flex align-items-center mb-0' : 'd-flex align-items-center']">
                            {{ mover.name }}
                            <span class="btn-status btn-created ml-1" v-if="mover.foreman">F</span>
                          </div>
                          <span class="message-status message-pending"
                                v-if="mover.confirmed === 'pending'"
                          >
                            <span class="send-to-all">A</span>
                            <span class="message-text message-pending-text">Pending</span>
                          </span>
                          <span class="message-status message-declined"
                                v-if="mover.confirmed === 'declined'"
                          >
                            <span class="send-to-all">A</span>
                            <span class="message-text message-text">Declined</span>
                          </span>
                          <span class="message-status message-confirmed"
                                v-if="mover.confirmed === 'confirmed'"
                          >
                            <span class="send-to-all">A</span>
                            <span class="message-text message-text">Confirmed</span>
                          </span>
                        </div>
                      </div>
                    </span>
                    <span v-else>
                      {{ job.assigned_movers.length }}/{{ job.movers }}
                    </span>
                  </div>
                  <div class="trucks btn-status" @click.self="showTrucksTooltip(!showTrucks)" :class="[
                    job.trucks === job.assigned_trucks.length ? 'turquoise-border-text' : 'orange-yellow-border-text',
                    job.assigned_trucks.length === 0 ? 'red-border-text' : '',
                  ]"
                  >
                    <span v-if="job.assigned_trucks.length" @click.self="showTrucksTooltip(!showTrucks)">
                      {{ job.assigned_trucks.length }}/{{ job.trucks }}
                      <div class="popover show-trucks-popover" v-if="job.assigned_trucks && showTrucks">
                        <div class="w-100 d-flex align-items-center justify-content-end">
                          <span @click.self="hideTrucksTooltip" class="mod-icon mod-icon-close" style="width: 10px; height: 10px" />
                        </div>
                        <div v-for="(truck, ind) in job.assigned_trucks"
                             :key="truck.id"
                        >
                          <p :class="[ind+1 === job.assigned_trucks.length ? 'mb-0' : 'mb-2']">
                            {{ truck.name }}
                          </p>
                        </div>
                      </div>
                    </span>
                    <span v-else>
                      {{ job.assigned_trucks.length }}/{{ job.trucks }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex col-12 p-0 d-lg-none d-xl-none">
          <div class="col-lg-6 col-md-5 d-flex">
            <div class="d-flex flex-column justify-content-start col-lg-7 col-md-12 col-12 pl-0">
              <span class="job-heading">
                Assigned to
              </span>
              <span class="pb-3 pt-8px" v-if="job.username">
                {{ job.username }}
              </span>

              <span class="pb-3 pt-8px" v-else>
                <i class="fa fa-exclamation-circle unassigned-icon" />
                Unassigned
              </span>
            </div>
          </div>
          <div class="col-lg-6 d-flex pr-0">
            <div class="d-flex flex-column justify-content-start col-lg-7 col-md-12 col-12 pl-0">
              <span class="job-heading">
                Move date
              </span>
              <span class="pb-3 pt-8px">
                {{ job.move_date }}
              </span>
            </div>
          </div>
        </div>
        <div class="d-flex col-12 p-0 d-lg-none d-xl-none">
          <div class="col-lg-6 col-md-5 d-flex">
            <div class="d-flex flex-column justify-content-start col-lg-7 col-md-12 col-12 pl-0">
              <span class="job-heading">
                Company
              </span>
              <span class="pb-3 pt-8px">
                {{ job.company }}
              </span>
            </div>
          </div>
          <div class="col-lg-6 d-flex pr-0">
            <div class="d-flex flex-column justify-content-start col-lg-7 col-md-12 col-12 pl-0">
              <span class="job-heading">
                Arrival window
              </span>
              <span class="pb-3 pt-8px" v-if="job.arrival_window_from || job.arrival_window_to">
                {{ formatTime(job.arrival_window_from) }} - {{ formatTime(job.arrival_window_to) }}
              </span>
              <span v-else class="pb-3 pt-8px">
                -
              </span>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-start col-12 p-0 responsive-handle">
          <div class="d-flex justify-content-start col-6" v-if="isCompletedOrCanceled && !job.claim" />
          <div class="d-flex justify-content-start col-6" v-if="isCompletedOrCanceled && job.claim">
            <div class="claim-unresolved col-12" v-if="isCompletedOrCanceled && job.claim && job.claim.claim_status_id !== 3">
              <div class="d-flex align-items-center justify-content-between h-100">
                <div class="d-flex align-items-center w-100">
                  <svg width="32" height="25" viewBox="0 0 32 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 14.9381C6.89543 14.9381 6 15.8336 6 16.9381V18.9257C6 20.0303 6.89543 20.9257 8 20.9257H18.0224C18.0076 20.7614 18 20.595 18 20.4268C18 17.3955 20.4624 14.9381 23.5 14.9381C23.7284 14.9381 23.968 14.9403 24.2115 14.9492C24.142 14.9419 24.0714 14.9381 24 14.9381H23.5H8Z" fill="#F57483" />
                    <rect x="6.5" y="8.45259" width="19" height="4.98761" rx="1.5" stroke="#F57483" />
                    <rect x="6.5" y="1.46704" width="19" height="4.98761" rx="1.5" stroke="#F57483" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M23.5 15.9361C21.0187 15.9361 19 17.9506 19 20.4268C19 22.9029 21.0187 24.9175 23.5 24.9175C25.9813 24.9175 28 22.903 28 20.4268C28 17.9506 25.9813 15.9361 23.5 15.9361ZM22.8066 18.6744C22.8066 18.2922 23.1171 17.9824 23.5 17.9824C23.883 17.9824 24.1934 18.2922 24.1934 18.6744V20.4268C24.1934 20.809 23.883 21.1188 23.5 21.1188C23.1171 21.1188 22.8066 20.809 22.8066 20.4268V18.6744ZM24.1797 22.3935C24.1844 22.3713 24.1875 22.3487 24.1898 22.3261C24.1922 22.3035 24.1936 22.2809 24.1936 22.2583C24.1936 22.2357 24.1922 22.2127 24.1899 22.1901C24.1876 22.1679 24.1844 22.1453 24.1797 22.1232C24.1756 22.1011 24.1696 22.0789 24.1631 22.0572C24.1567 22.036 24.1488 22.0144 24.1405 21.9936C24.1317 21.9728 24.1219 21.9521 24.1114 21.9322C24.1007 21.9124 24.0892 21.893 24.0767 21.8741C24.0642 21.8552 24.0504 21.8367 24.036 21.8197C24.0217 21.8022 24.0065 21.7851 23.9903 21.7689C23.9746 21.7532 23.9575 21.7376 23.9399 21.7233C23.9223 21.709 23.9038 21.6956 23.8849 21.6831C23.8663 21.6707 23.8465 21.6587 23.8266 21.6481C23.8067 21.6375 23.7859 21.6278 23.7651 21.6195C23.7443 21.6107 23.7231 21.6029 23.7014 21.5964C23.6796 21.59 23.6579 21.5844 23.6357 21.5798C23.6135 21.5752 23.5908 21.5719 23.5682 21.5696C23.5229 21.565 23.4771 21.565 23.4319 21.5696C23.4097 21.572 23.3871 21.5752 23.3648 21.5798C23.3426 21.5844 23.3205 21.59 23.2987 21.5964C23.277 21.6029 23.2557 21.6107 23.235 21.6195C23.2141 21.6278 23.1933 21.6374 23.1735 21.6481C23.1535 21.6587 23.1341 21.6707 23.1152 21.6831C23.0963 21.6956 23.0777 21.709 23.0606 21.7233C23.0426 21.7375 23.026 21.7532 23.0098 21.7689C22.9936 21.785 22.9784 21.8021 22.964 21.8197C22.9497 21.8367 22.9363 21.8552 22.9238 21.8741C22.9108 21.893 22.8992 21.9124 22.8887 21.9322C22.878 21.9521 22.8683 21.9728 22.86 21.9936C22.8513 22.0144 22.8434 22.036 22.8369 22.0572C22.8305 22.0789 22.8249 22.1011 22.8203 22.1232C22.8156 22.1453 22.8124 22.1679 22.8101 22.1901C22.8078 22.2127 22.8068 22.2357 22.8068 22.2583C22.8068 22.2809 22.8077 22.3035 22.8101 22.3261C22.8124 22.3487 22.8156 22.3713 22.8203 22.3935C22.8249 22.4156 22.8305 22.4378 22.8369 22.459C22.8434 22.4807 22.8513 22.5019 22.86 22.5226C22.8683 22.5434 22.878 22.5642 22.8887 22.584C22.8993 22.6038 22.9108 22.6237 22.9238 22.6421C22.9363 22.661 22.9496 22.6795 22.964 22.697C22.9783 22.7145 22.9935 22.7316 23.0098 22.7473C23.0259 22.7635 23.0426 22.7786 23.0606 22.7934C23.0777 22.8073 23.0963 22.8211 23.1152 22.8336C23.1341 22.846 23.1535 22.8575 23.1735 22.8682C23.1933 22.8788 23.2141 22.8885 23.235 22.8972C23.2557 22.906 23.277 22.9134 23.2987 22.9198C23.3205 22.9268 23.3426 22.9323 23.3648 22.9364C23.387 22.9411 23.4097 22.9448 23.4319 22.9466C23.4545 22.9489 23.4776 22.9503 23.5002 22.9503C23.5229 22.9503 23.5455 22.9489 23.5682 22.9466C23.5908 22.9447 23.6135 22.941 23.6357 22.9364C23.6579 22.9323 23.6795 22.9267 23.7013 22.9198C23.723 22.9134 23.7443 22.906 23.7651 22.8972C23.7859 22.8885 23.8067 22.8788 23.8266 22.8682C23.8465 22.8575 23.8663 22.846 23.8848 22.8336C23.9038 22.8211 23.9222 22.8073 23.9399 22.7934C23.9574 22.7787 23.9745 22.7635 23.9902 22.7473C24.0064 22.7317 24.0216 22.7146 24.0359 22.697C24.0503 22.6795 24.0641 22.661 24.0767 22.6421C24.0892 22.6237 24.1007 22.6038 24.1113 22.584C24.1219 22.5642 24.1317 22.5434 24.1404 22.5226C24.1487 22.5019 24.1566 22.4807 24.163 22.459C24.1695 22.4378 24.1755 22.4156 24.1797 22.3935Z" fill="#F57483" />
                  </svg>
                  <p class="pl-3 claim-unresolved-title">Unresolved claim - {{ job.claim.title }}</p>
                </div>
                <router-link :to="{ path: '/claims/edit/' + job.claim.id}" target="_blank">
                  <div class="d-flex pointer align-items-center justify-content-end">
                    <span class="see-claim-unresolved">See claim</span>
                    <svg class="claim-unresolved-icon pl-2" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16.01 11.2955H4V13.2955H16.01V16.2955L20 12.2955L16.01 8.29553V11.2955Z" fill="#F57483" />
                    </svg>
                  </div>
                </router-link>
              </div>
            </div>
            <div class="claim-resolved col-lg-12 col-12" v-if="isCompletedOrCanceled && job.claim && job.claim.claim_status_id === 3">
              <div class="d-flex align-items-center justify-content-between h-100">
                <div class="d-flex align-items-center w-100">
                  <svg width="32" height="25" viewBox="0 0 32 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 14.9381C6.89543 14.9381 6 15.8336 6 16.9381V18.9257C6 20.0303 6.89543 20.9257 8 20.9257H18.0224C18.0076 20.7614 18 20.595 18 20.4268C18 17.3955 20.4624 14.9381 23.5 14.9381C23.7284 14.9381 23.968 14.9403 24.2115 14.9492C24.142 14.9419 24.0714 14.9381 24 14.9381H23.5H8Z" fill="#2DB300" />
                    <rect x="6.5" y="8.45259" width="19" height="4.98761" rx="1.5" stroke="#2DB300" />
                    <rect x="6.5" y="1.46704" width="19" height="4.98761" rx="1.5" stroke="#2DB300" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M23.5 15.9361C21.0187 15.9361 19 17.9506 19 20.4268C19 22.9029 21.0187 24.9175 23.5 24.9175C25.9813 24.9175 28 22.903 28 20.4268C28 17.9506 25.9813 15.9361 23.5 15.9361ZM22.8066 18.6744C22.8066 18.2922 23.1171 17.9824 23.5 17.9824C23.883 17.9824 24.1934 18.2922 24.1934 18.6744V20.4268C24.1934 20.809 23.883 21.1188 23.5 21.1188C23.1171 21.1188 22.8066 20.809 22.8066 20.4268V18.6744ZM24.1797 22.3935C24.1844 22.3713 24.1875 22.3487 24.1898 22.3261C24.1922 22.3035 24.1936 22.2809 24.1936 22.2583C24.1936 22.2357 24.1922 22.2127 24.1899 22.1901C24.1876 22.1679 24.1844 22.1453 24.1797 22.1232C24.1756 22.1011 24.1696 22.0789 24.1631 22.0572C24.1567 22.036 24.1488 22.0144 24.1405 21.9936C24.1317 21.9728 24.1219 21.9521 24.1114 21.9322C24.1007 21.9124 24.0892 21.893 24.0767 21.8741C24.0642 21.8552 24.0504 21.8367 24.036 21.8197C24.0217 21.8022 24.0065 21.7851 23.9903 21.7689C23.9746 21.7532 23.9575 21.7376 23.9399 21.7233C23.9223 21.709 23.9038 21.6956 23.8849 21.6831C23.8663 21.6707 23.8465 21.6587 23.8266 21.6481C23.8067 21.6375 23.7859 21.6278 23.7651 21.6195C23.7443 21.6107 23.7231 21.6029 23.7014 21.5964C23.6796 21.59 23.6579 21.5844 23.6357 21.5798C23.6135 21.5752 23.5908 21.5719 23.5682 21.5696C23.5229 21.565 23.4771 21.565 23.4319 21.5696C23.4097 21.572 23.3871 21.5752 23.3648 21.5798C23.3426 21.5844 23.3205 21.59 23.2987 21.5964C23.277 21.6029 23.2557 21.6107 23.235 21.6195C23.2141 21.6278 23.1933 21.6374 23.1735 21.6481C23.1535 21.6587 23.1341 21.6707 23.1152 21.6831C23.0963 21.6956 23.0777 21.709 23.0606 21.7233C23.0426 21.7375 23.026 21.7532 23.0098 21.7689C22.9936 21.785 22.9784 21.8021 22.964 21.8197C22.9497 21.8367 22.9363 21.8552 22.9238 21.8741C22.9108 21.893 22.8992 21.9124 22.8887 21.9322C22.878 21.9521 22.8683 21.9728 22.86 21.9936C22.8513 22.0144 22.8434 22.036 22.8369 22.0572C22.8305 22.0789 22.8249 22.1011 22.8203 22.1232C22.8156 22.1453 22.8124 22.1679 22.8101 22.1901C22.8078 22.2127 22.8068 22.2357 22.8068 22.2583C22.8068 22.2809 22.8077 22.3035 22.8101 22.3261C22.8124 22.3487 22.8156 22.3713 22.8203 22.3935C22.8249 22.4156 22.8305 22.4378 22.8369 22.459C22.8434 22.4807 22.8513 22.5019 22.86 22.5226C22.8683 22.5434 22.878 22.5642 22.8887 22.584C22.8993 22.6038 22.9108 22.6237 22.9238 22.6421C22.9363 22.661 22.9496 22.6795 22.964 22.697C22.9783 22.7145 22.9935 22.7316 23.0098 22.7473C23.0259 22.7635 23.0426 22.7786 23.0606 22.7934C23.0777 22.8073 23.0963 22.8211 23.1152 22.8336C23.1341 22.846 23.1535 22.8575 23.1735 22.8682C23.1933 22.8788 23.2141 22.8885 23.235 22.8972C23.2557 22.906 23.277 22.9134 23.2987 22.9198C23.3205 22.9268 23.3426 22.9323 23.3648 22.9364C23.387 22.9411 23.4097 22.9448 23.4319 22.9466C23.4545 22.9489 23.4776 22.9503 23.5002 22.9503C23.5229 22.9503 23.5455 22.9489 23.5682 22.9466C23.5908 22.9447 23.6135 22.941 23.6357 22.9364C23.6579 22.9323 23.6795 22.9267 23.7013 22.9198C23.723 22.9134 23.7443 22.906 23.7651 22.8972C23.7859 22.8885 23.8067 22.8788 23.8266 22.8682C23.8465 22.8575 23.8663 22.846 23.8848 22.8336C23.9038 22.8211 23.9222 22.8073 23.9399 22.7934C23.9574 22.7787 23.9745 22.7635 23.9902 22.7473C24.0064 22.7317 24.0216 22.7146 24.0359 22.697C24.0503 22.6795 24.0641 22.661 24.0767 22.6421C24.0892 22.6237 24.1007 22.6038 24.1113 22.584C24.1219 22.5642 24.1317 22.5434 24.1404 22.5226C24.1487 22.5019 24.1566 22.4807 24.163 22.459C24.1695 22.4378 24.1755 22.4156 24.1797 22.3935Z" fill="#2DB300" />
                  </svg>
                  <p class="pl-3 d-block claim-resolved-title text-truncate">Closed claim ({{ job.claim.claim_resolution }}) - {{ job.claim.title }}</p>
                </div>
                <router-link :to="{ path: '/claims/edit/' + job.claim.id}" target="_blank">
                  <div class="d-flex pointer align-items-center justify-content-end">
                    <span class="see-claim-resolved">See claim</span>
                    <svg class="claim-resolved-icon pl-2" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16.01 11.2955H4V13.2955H16.01V16.2955L20 12.2955L16.01 8.29553V11.2955Z" fill="#2DB300" />
                    </svg>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-start col-6" v-if="job.status_id === 30 && job.claim && job.claim.id === null">
            <div class="job-cancelled col-12">
              <div class="d-flex align-items-center justify-content-between h-100">
                <div class="d-flex align-items-center w-100">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                      <rect width="24" height="24" fill="white" />
                    </mask>
                    <g mask="url(#mask0)">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9125 8.42724L15.5727 7.08746L12 10.6602L8.42725 7.08746L7.08747 8.42724L10.6602 12L7.08747 15.5727L8.42725 16.9125L12 13.3398L15.5728 16.9125L16.9125 15.5727L13.3398 12L16.9125 8.42724Z" fill="#F57483" />
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="#F57483" />
                    </g>
                  </svg>
                  <p class="pl-3 job-cancelled-title">Job cancelled {{ job.cancellation_status_log.note ? '- ' + job.cancellation_status_log.note : '' }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-start col-6" v-if="!isCompletedOrCanceled && job.changes > 0 && !isInProgressTrackingOrPayment && job.status_id !== 21">
            <div class="job-changes col-12">
              <div class="d-flex align-items-center justify-content-between h-100">
                <div class="d-flex align-items-center w-100">
                  <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9C10 10.1 10.9 11 12 11C13.1 11 14 10.1 14 9ZM12 0C7.03 0 3 4.03 3 9H0L4 13L8 9H5C5 5.13 8.13 2 12 2C15.87 2 19 5.13 19 9C19 12.87 15.87 16 12 16C10.49 16 9.09 15.51 7.94 14.7L6.52 16.14C8.04 17.3 9.94 18 12 18C16.97 18 21 13.97 21 9C21 4.03 16.97 0 12 0Z" fill="#2962FF" />
                  </svg>
                  <p class="pl-3 job-changes-title">{{ job.changes }} new updates for this job</p>
                </div>
                <router-link :to="{ path: '/jobs/edit/' + job.id}" target="_blank">
                  <div class="d-flex pointer align-items-center justify-content-end">
                    <span class="see-job-changes">See details</span>
                    <svg class="job-changes-icon pl-2" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16.01 11.2955H4V13.2955H16.01V16.2955L20 12.2955L16.01 8.29553V11.2955Z" fill="#2962FF" />
                    </svg>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-start col-6" v-if="isInProgressTrackingOrPayment">
            <div class="movers-working col-12">
              <div class="d-flex align-items-center justify-content-between h-100">
                <div class="d-flex align-items-center w-100">
                  <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 4H16V0H2C0.9 0 0 0.9 0 2V13H2C2 14.66 3.34 16 5 16C6.66 16 8 14.66 8 13H14C14 14.66 15.34 16 17 16C18.66 16 20 14.66 20 13H22V8L19 4ZM5 14.5C4.17 14.5 3.5 13.83 3.5 13C3.5 12.17 4.17 11.5 5 11.5C5.83 11.5 6.5 12.17 6.5 13C6.5 13.83 5.83 14.5 5 14.5ZM18.5 5.5L20.46 8H16V5.5H18.5ZM17 14.5C16.17 14.5 15.5 13.83 15.5 13C15.5 12.17 16.17 11.5 17 11.5C17.83 11.5 18.5 12.17 18.5 13C18.5 13.83 17.83 14.5 17 14.5Z" fill="#5B30EC" />
                  </svg>
                  <p class="pl-3 movers-working-title">Movers are currently working on this job.</p>
                </div>
                <router-link :to="{ path: '/jobs/edit/' + job.id}" target="_blank">
                  <div class="d-flex pointer align-items-center justify-content-end">
                    <span class="see-movers-working">See details</span>
                    <svg class="movers-working-icon pl-2" width="24" height="25" viewBox="0 0 24 25" fill="5B30EC" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16.01 11.2955H4V13.2955H16.01V16.2955L20 12.2955L16.01 8.29553V11.2955Z" fill="#2962FF" />
                    </svg>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-start col-6" v-if="job.status_id === 21">
            <div class="job-on-hold col-12">
              <div class="d-flex align-items-center justify-content-between h-100">
                <div class="d-flex align-items-center w-100">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.89 22 12 22ZM18 16V11C18 7.93 16.36 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.63 5.36 6 7.93 6 11V16L4 18V19H20V18L18 16ZM14.5 9.8L11.7 13.2H14.5V15H9.5V13.2L12.3 9.8H9.5V8H14.5V9.8Z" fill="#FFAB00" />
                  </svg>
                  <p class="pl-3 job-on-hold-title">Job on hold</p>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-center col-6">
            <div class="col-6">
              <span class="d-flex align-items-center" v-if="job.ratings && job.ratings[0]">
                <div class="mr-2">{{ job.ratings[0].diff_for_humans }}</div>
                <star-rating :rating="job.ratings[0].rating"
                             :star-size="15"
                             :show-rating="false"
                             :increment="0.1"
                             :read-only="true"
                />
              </span>
            </div>
            <div class="d-flex justify-content-end col-6 pr-0" v-if="job.status_id === 16">
              <div class="col-lg-12 col-12 d-flex flex-column justify-content-end align-items-end pr-0">
                <span class="total-price-text">Total price</span>
                <span class="job-price">${{ job.price }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <modal v-if="showCarrierReassignModal"
             @close="closeReassignCarrierModal"
             :size="'modal-large'"
      >
        <div slot="header">
          <h4>Assign carrier</h4>
        </div>
        <div slot="body">
          <p v-if="job.carrier">
            Changing carrier will remove all movers and trucks from this move.
          </p>
          <div class="d-flex flex-column">
            <div class="form-row">
              <div class="col-4 text-right pt-2 pl-0 cc-n-umber radio-button-wrap ml-3" />
              <div class="row col-md-8">
                <div class="col-md-3 d-flex align-items-center justify-content-center">
                  <small class="text-secondary">Movers AM</small>
                </div>
                <div class="col-md-3 d-flex align-items-center justify-content-center">
                  <small class="text-secondary">Movers PM</small>
                </div>
                <div class="col-md-3 d-flex align-items-center justify-content-center">
                  <small class="text-secondary">Trucks AM</small>
                </div>
                <div class="col-md-3 d-flex align-items-center justify-content-center">
                  <small class="text-secondary">Trucks PM</small>
                </div>
              </div>
            </div>
            <div v-for="carrier in carriersForAssign" @click="setCarrier(carrier.id, carrier.name)" :key="carrier.id" class="form-row" :class="{'radio-border-blue': carrierId === carrier.id}">
              <div class="col-4 text-right pt-2 pl-0 cc-n-umber radio-button-wrap ml-3">
                <label class="pointer text-left w-100 h-100 d-flex align-items-center">
                  <input :checked="carrierId === carrier.id" type="radio" :id="'carrier-'+carrier.id" />
                  <span class="btn-radio" />
                  <label :for="'carrier-'+carrier.id" class="btn-radio-label" v-text="carrier.name" />
                </label>
              </div>
              <div class="row col-md-8">
                <div class="col-md-3 d-flex align-items-center justify-content-center">
                  <span class="btn-status btn-amount" :class="[giveStyleAssignCarrierAvailability(carrier, 'movers', 'am')]" v-text="carrier.available_movers_am+ ' / '+carrier.total_movers" />
                </div>
                <div class="col-md-3 d-flex align-items-center justify-content-center">
                  <span class="btn-status btn-amount" :class="[giveStyleAssignCarrierAvailability(carrier, 'movers', 'pm')]" v-text="carrier.available_movers_pm + ' / ' +carrier.total_movers" />
                </div>
                <div class="col-md-3 d-flex align-items-center justify-content-center">
                  <span class="btn-status btn-amount" :class="[giveStyleAssignCarrierAvailability(carrier, 'trucks', 'am')]" v-text="carrier.available_trucks_am+ ' / '+carrier.total_trucks" />
                </div>
                <div class="col-md-3 d-flex align-items-center justify-content-center">
                  <span class="btn-status btn-amount" :class="[giveStyleAssignCarrierAvailability(carrier, 'movers', 'pm')]" v-text="carrier.available_trucks_pm + ' / ' +carrier.total_trucks" />
                </div>
              </div>
            </div>
          </div>
          <error-field :errors="errors" field="availability" />
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-12 text-center">
              <button class="btn btn-secondary" type="button" @click="closeReassignCarrierModal">Discard</button>
              <button type="button" class="btn btn-primary" @click="reassignCarrier" v-text="job.carrier ? 'Reassign' : 'Assign'" />
            </div>
          </div>
        </div>
      </modal>

      <!--  Accept job modal  -->
      <modal v-if="showModalAcceptJob" @close="showModalAcceptJob = false">
        <div slot="header">
          <h4 class="pb-2">{{ job.ref_id }} - Accept job</h4>
        </div>
        <div slot="body">
          <div class="row mb-2">
            <div class="col">
              <div>
                <p class="mb-1">
                  Move <b>{{ job.ref_id }}</b> was marked as  <span v-if="job.is_small === 1">a</span><span v-else>an</span> {{ isSmallJob }},
                  <span v-if="job.is_small === 1">deselect if it is a all day job.</span><span v-else>select it if its a small job.</span>
                </p><div class="customer-check-field">
                  <span class="customer-checkmark" />
                  Small job
                  <input type="checkbox"
                         :value="job.is_small"
                         :checked="job.is_small === 1"
                         @change="changeSmallJob"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-12 text-right">
              <button class="btn btn-secondary" type="button" @click="showModalAcceptJob = false">Discard</button>
              <button class="btn btn-primary" @click="changeStatus(job.id, 3)">Accept</button>
            </div>
          </div>
        </div>
      </modal>

      <!-- Modal cancel job -->
      <modal v-if="showModalCancelJob" @close="showModalCancelJob = false">
        <div slot="header">
          <h4>{{ job.ref_id }} - Cancellation note</h4>
        </div>
        <div slot="body">
          <div class="row mb-2">
            <div class="col">
              <div class="select-wrap h-auto">
                <label>Note</label>
                <textarea rows="5" class="select-wrap-textarea form-control" v-model="note"
                          @keydown="clearError($event)"
                />
              </div>
              <error-field :errors="errors" field="note" />
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-12 text-right">
              <button class="btn btn-secondary" type="button" @click="showModalCancelJob = false">Discard</button>
              <button class="btn btn-primary" @click="changeStatus(job.id, 30)">Proceed</button>
            </div>
          </div>
        </div>
      </modal>

      <!-- Modal reject job -->
      <modal v-if="showModalRejectJob" @close="showModalRejectJob = false">
        <div slot="header">
          <h4 class="pb-2">{{ job.ref_id }} - Rejection note</h4>
        </div>
        <div slot="body">
          <div class="row mb-2">
            <div class="col">
              <p class="mb-1">
                Move <b>{{ job.ref_id }}</b> was marked as <span v-if="job.is_small === 1">a</span><span v-else>an</span> {{ isSmallJob }},
                <span v-if="job.is_small === 1">deselect it for an all day job.</span><span v-else>select it for a small job.</span>
              </p>
              <div class="customer-check-field pb-3">
                <span class="customer-checkmark" />
                Small job
                <input type="checkbox"
                       :value="job.is_small"
                       :checked="job.is_small === 1"
                       @change="changeSmallJob"
                />
              </div>
              <div class="select-wrap h-auto mt-3">
                <label>Note</label>
                <textarea class="select-wrap-textarea form-control" rows="5" v-model="note"
                          @keydown="clearError($event)"
                />
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-12 text-right">
              <button class="btn btn-secondary" type="button" @click="showModalRejectJob = false">Discard</button>
              <button class="btn btn-primary" @click="changeStatus(job.id, 31)">Proceed</button>
            </div>
          </div>
        </div>
      </modal>

      <!--  Small job modal  -->
      <modal v-if="showModalIsSmallJob" @close="showModalIsSmallJob = false">
        <div slot="header">
          <h4 class="pb-2">{{ job.ref_id }} - Job size</h4>
        </div>
        <div slot="body">
          <div class="row mb-2">
            <div class="col">
              <div>
                <p class="mb-1">
                  Move <b>{{ job.ref_id }}</b> was marked as  <span v-if="job.is_small === 1">a</span><span v-else>an</span> {{ isSmallJob }},
                  <span v-if="job.is_small === 1">deselect if it is a all day job.</span><span v-else>select it if its a small job.</span>
                </p>
                <div class="customer-check-field">
                  <span class="customer-checkmark" />
                  Small job
                  <input type="checkbox"
                         :value="job.is_small"
                         :checked="job.is_small === 1"
                         @change="changeSmallJob"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-12 text-right">
              <button class="btn btn-primary" type="button" @click="save">Save</button>
            </div>
          </div>
        </div>
      </modal>

      <!-- reassignUser modal -->
      <modal v-if="showUserReassignModal" @close="showUserReassignModal = false" :size="'modal-large'"
             :close-strict="true"
      >
        <div slot="header">
          <div class="row">
            <div class="col-10">
              <div>
                <h4>{{ job.ref_id }} - Select user to assign job to</h4>
              </div>
            </div>
          </div>
        </div>
        <div slot="body">
          <div class="select-wrap">
            <label>Select User</label>
            <simple-select v-model="assigneeId"
                           :options="assignees"
                           @change="clearError($event)"
            />
          </div>
          <error-field :errors="errors" field="cluster_user_id" />
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-12">
              <button type="button" class="btn btn-primary pull-right" @click="reassignUser">
                Reassign
              </button>
            </div>
          </div>
        </div>
      </modal>

      <!-- set cash collected modal -->
      <modal v-if="cashCollectModal"
             @close="cashCollectModal = false"
             :size="'modal-large'"
             :close-strict="false"
      >
        <div slot="header">
          <h4 v-if="!job.cash_collected">
            Cash collect
          </h4>
          <h4 v-else>
            Cash not collected
          </h4>
        </div>
        <div slot="body">
          <div class="text-center">
            <template v-if="!job.cash_collected">
              This will mark that the cash was collected for this job. Do you want to proceed?
            </template>
            <template v-else>
              This will mark that the cash was not collected for this job. Do you want to proceed?
            </template>
          </div>
          <div class="d-flex align-items-center justify-content-center mt-3" style="gap: 15px">
            <button class="btn btn-secondary" type="button" @click="cashCollectModal = false;">No</button>
            <button type="button" class="btn btn-primary" @click="setCashCollected">Yes</button>
          </div>
        </div>
        <div slot="footer">
          <div class="d-flex align-items-center justify-content-end w-100" />
        </div>
      </modal>
    </template>
  </div>
</template>
<script>
import axios from 'axios';
import toastr from 'toastr';
import moment from 'moment';
import { mapState } from 'vuex';
import Modal from '../Modal';
import customTooltip from '../CustomTooltip';
import PhoneMask from '../../classes/PhoneMask';
import Errors from '../../classes/Errors';
import TagColor from '../settings/Tags/TagColor';
import CustomerNote from '../CustomerNote.vue';

export default {
  components: {
    TagColor,
    Modal,
    customTooltip,
    CustomerNote,
  },
  props: {
    dashboard: {
      type: Boolean,
      default: false,
    },
    job: {
      type: Object,
      default: () => {},
    },
    q: {
      type: String,
      default: () => '',
    },
    index: {
      type: Number,
      default: () => 0,
    },
    expanded: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    assignees: [],
    carrierId: null,
    carrierName: null,
    companiesWithCoverage: [],
    carriersForAssign: [],
    note: '',
    buttonDisabled: false,
    jobLoading: false,
    visible: false,
    showReassignModal: false,
    showDropdownStatus: false,
    showCarrierReassignModal: false,
    showModalCancelJob: false,
    showModalAcceptJob: false,
    showModalRejectJob: false,
    showModalIsSmallJob: false,
    showUserReassignModal: false,
    canSeeCustomerInfo: false,
    assigneeId: null,
    phoneMask: new PhoneMask(),
    errors: new Errors(),
    showMovers: {
      showTooltip: '',
    },
    showTrucks: false,
    showMoversToday: [],
    showTrucksToday: [],
    showMoversTomorrow: [],
    showTrucksTomorrow: [],
    showAllAddresses: false,
    showModalCustomerNote: false,
    cashCollectModal: false,
  }),
  computed: {
    ...mapState({
      jobStatuses: state => state.values.jobStatuses,
      user: state => state.auth.dispatchUser,
    }),
    canShowCashCollect() {
      return (
        this.job.status_id === 16 ||
        this.job.status_id === 41 ||
        this.job.status_id === 42 ||
        this.job.status_id === 47
      );
    },
    showCustomerInfo() {
      return this.$_can('customer-info-subco.show') || this.canSeeCustomerInfo;
    },
    isSmallJob() {
      if (this.job.is_small === 1) {
        return 'Small job';
      }
      return 'All day job';
    },
    isActive() {
      return (
        this.job.status &&
        this.job.status.name !== 'Canceled' &&
        this.job.status.name !== 'Completed'
      );
    },
    isCompletedOrCanceled() {
      return this.job.status_id === 16 || this.job.status_id === 30;
    },
    isInProgressTrackingOrPayment() {
      return this.job.status_id === 40 || this.job.status_id === 41 || this.job.status_id === 42;
    },
    canLeaveNote() {
      return (
        (this.job.status.name === 'Canceled' || this.job.status.name === 'Completed') &&
        !this.job.customer_note
      );
    },
    userHasAccessToCarrier() {
      if (this.user.roles.some(role => role.id === 1)) {
        return true;
      }
      if (!this.job.carrier) {
        return true;
      }
      return this.user.carriers.some(carrier => carrier.id === this.job.carrier_id);
    },
  },
  watch: {
    job() {
      this.checkDate();
    },
  },
  mounted() {
    this.checkDate();
    const vm = this;
    if (this.dashboard) {
      window.echo.private(`job.${this.job.id}`).listen('.jobUpdated', () => {
        if (vm.$route.name === 'Dashboard' && !this.jobLoading) {
          vm.getJob();
        }
      });
    }
    this.carrierId = this.job.carrier_id ? this.job.carrier_id : null;
    this.carrierName = this.job.carrier_name ? this.job.carrier_name : null;
  },
  methods: {
    setCashCollected() {
      axios.post(`/jobs/${this.job.id}/cash-collect`).then(() => {
        this.cashCollectModal = false;
        this.getJob();
      });
    },
    saveCustomerNote(callback) {
      this.job.customer_note = callback();
      this.showModalCustomerNote = false;
    },
    getJob(jobMessage, callback) {
      axios
        .get(`/jobs/list/${this.job.id}`)
        .then(res => {
          this.job = res.data.data;
          if (jobMessage) toastr.success(jobMessage);
          if (callback) callback();
        })
        .finally(() => {
          this.jobLoading = false;
        });
    },
    getCarriers() {
      axios
        .get(`carriers/job/${this.job.id}`)
        .then(res => {
          this.carriersForAssign = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    reassignCarrierModal() {
      this.getCarriers();
      this.showCarrierReassignModal = true;
    },
    closeReassignCarrierModal() {
      this.showCarrierReassignModal = false;
    },
    reassignCarrier() {
      this.jobLoading = true;
      axios
        .patch(`jobs/${this.job.id}`, { carrier_id: this.carrierId })
        .then(() => {
          this.getJob('Successfully reassigned job');
          this.showCarrierReassignModal = false;
        })
        .catch(err => this.errors.record(err.response.data.error))
        .finally(() => {
          this.jobLoading = false;
        });
    },
    giveStyleAssignCarrierAvailability(carrier, type, dayPeriod) {
      let availability = 0;
      if (type === 'movers') {
        availability =
          dayPeriod.toLowerCase() === 'am'
            ? carrier.available_movers_am
            : carrier.available_movers_pm;
      } else if (type === 'trucks') {
        availability =
          dayPeriod.toLowerCase() === 'am'
            ? carrier.available_trucks_am
            : carrier.available_trucks_pm;
      }

      if (availability === 0) {
        return 'orange-yellow-border-text red-border-text';
      }
      if (availability !== parseInt(carrier[`total_${type}`], 0)) {
        return 'orange-yellow-border-text';
      }
      return 'turquoise-border-text';
    },
    changeSmallJob() {
      this.job.is_small = Number(!this.job.is_small);
    },
    restoreStatus() {
      this.jobLoading = true;
      axios
        .patch(`jobs/${this.job.id}/restore-status`)
        .then(() => {
          this.getJob('Successfully restored job');
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    setCarrier(carrierId, carrierName) {
      this.carrierId = carrierId;
      this.carrierName = carrierName;
    },
    /*    sendContractEmail() {
      axios
        .post(`jobs/${this.job.id}/mails/contract`)
        .then(() => {
          this.getJob('Successfully sent pre-agreement email')
        })
        .catch(err => {
          if (err.response.data.error.contract) {
            toastr.error(err.response.data.error.contract);
          } else {
            toastr.error(err.response.data.error);
          }
        });
    }, */
    reassignUserModal() {
      axios
        .get(`clusters/users/sales`)
        .then(res => {
          res.data.data.forEach(assignee => {
            assignee.name = `${assignee.first_name} ${assignee.last_name}`;
          });
          this.assignees = res.data.data;
          this.showUserReassignModal = true;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    reassignUser() {
      this.jobLoading = true;
      axios
        .patch(`jobs/${this.job.id}/cluster-user`, { cluster_user_id: this.assigneeId })
        .then(() => {
          this.getJob('Successfully reassigned job');
          this.showUserReassignModal = false;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    save() {
      this.showModalIsSmallJob = false;
      if (this.isActive) {
        this.buttonDisabled = true;
        this.loadingButton = true;
        if (Number.isNaN(this.job.price_per_hour)) {
          this.$set(
            this.job,
            'price_per_hour',
            parseFloat(this.job.price_per_hour.replace(/,/g, '')),
          );
        }
        axios
          .put(`jobs/${this.job.id}`, {
            is_small: this.job.is_small,
          })
          .then(() => {
            this.getJob('Successfully updated job');
          })
          .catch(err => {
            if (err.response.data.error.addresses) {
              toastr.error(err.response.data.error.addresses[0]);
            }
            if (err.response.data.error.booking) {
              toastr.error(err.response.data.error.booking[0]);
            }
            this.errors.record(err.response.data.error);
          })
          .finally(() => {
            this.loadingButton = false;
            this.buttonDisabled = false;
          });
      }
    },
    changeStatus(id, statusId) {
      if (statusId) {
        this.$set(this.job, 'status', this.jobStatuses.find(s => s.id === statusId).name);
        this.showDropdownStatus = false;
        this.showModalRejectJob = false;
        this.showModalAcceptJob = false;
        this.jobLoading = true;
        axios
          .put(`jobs/${id}/status`, { status_id: statusId, note: this.note })
          .then(() => {
            this.showModalCancelJob = false;
            this.getJob('Successfully updated status');
            this.note = '';
          })
          .catch(err => {
            this.errors.record(err.response.data.error);
          });
      }
    },
    copyToClipboard(refId, message) {
      this.$copyText(refId).then(() => toastr.success(message, '', { timeOut: 1000 }));
    },
    toggleJob(id) {
      this.$emit('expanded', id);
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    viewInNewTab(event, id) {
      this.$emit('setFiltersSaved');
      const routeData = this.$router.resolve({
        path: `/jobs/edit/${id}`,
        query: { q: this.q.toUpperCase() },
      });
      window.open(routeData.href, '_blank');
    },
    view(event, id) {
      this.$router.push(
        `/jobs/edit/${id}${this.q ? `?q=${encodeURIComponent(this.q.toUpperCase())}` : ''}`,
      );
    },
    formatTime(time) {
      return moment(time, 'HH:mm').format('hh:mm A');
    },
    showMoversTooltip(index) {
      this.showMovers.showTooltip = index;
    },
    hideMoversTooltip() {
      this.showMovers.showTooltip = false;
    },
    showTrucksTooltip(val) {
      this.showTrucks = val;
    },
    hideTrucksTooltip() {
      this.showTrucks = false;
    },
    checkDate() {
      if (
        moment(this.job.move_date, 'MM-DD-YYYY h:m a').format('YYYY-MM-DD') <=
        moment()
          .subtract('1', 'd')
          .format('YYYY-MM-DD')
      ) {
        this.canSeeCustomerInfo = true;
      } else if (
        moment(this.job.move_date, 'MM-DD-YYYY h:m a').format('YYYY-MM-DD') ===
        moment().format('YYYY-MM-DD')
      ) {
        this.canSeeCustomerInfo = true;
      } else if (
        moment(this.job.move_date, 'MM-DD-YYYY h:m a').format('YYYY-MM-DD') ===
        moment()
          .add('1', 'd')
          .format('YYYY-MM-DD')
      ) {
        this.canSeeCustomerInfo = true;
      } else {
        this.canSeeCustomerInfo = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.job-block-font {
  font-size: 13px !important;
}

a {
  color: inherit !important;
  width: 100%;
  text-decoration: none;
}
a:hover {
  color: inherit !important;
  text-decoration: none !important;
}
.flat-rate-indicator {
  position: absolute;
  left: -25%;
}
.message-status {
  max-height: 17px;
  font-size: 10px;
}
.job-list-cancelation-note .tippy-info-popover {
  min-width: 200px !important;
  left: 0 !important;
}
a {
  text-decoration: none;
}
.lds-ellipsis {
  display: flex;
  justify-content: center;
  height: 45px;
  padding-top: 11px;
}

.lds-ellipsis div {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 10px !important;
  background: #e3e3e3;
  animation: loader 0.6s infinite alternate;
}

.lds-ellipsis > div:nth-child(2) {
  animation-delay: 0.2s;
}

.lds-ellipsis > div:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes loader {
  to {
    opacity: 0.1;
    transform: translate(0, -20px);
    background: #e0e5ea;
  }
}
.job-heading {
  font-weight: 500;
  font-size: 12px;
  color: #4c5669;
}
.list-box-status {
  align-items: normal;
}
.expand-jobs {
  height: 40px;
  width: 40px;
  margin-left: 10px;
  background-size: auto;
  background: linear-gradient(180deg, #ffffff 0%, #f9fafb 100%);
  border: 1px solid #c4cdd5;
  box-shadow: 0 1px 0 rgba(22, 29, 37, 0.05);
  border-radius: 3px;
}
.fa-circle {
  position: relative;

  &:after {
    content: '';
    top: 13px;
    left: 5.5px;
    position: absolute;
    width: 1px;
    min-height: 70px;
    background-color: grey;
  }
}
.circles-wrap > div:last-child .fa-circle:after {
  display: none;
}
.address-text {
  line-height: 1;
  font-size: 13px;
  padding-left: 5px;
}
.apt-floor {
  font-size: 11px;
  color: #979797;
}
.fa-circle-with-apt {
  position: relative;

  &:after {
    content: '';
    top: 13px;
    left: 5.5px;
    position: absolute;
    width: 1px;
    min-height: 84px;
    background-color: grey;
  }
}
.remaining-addresses {
  background: white;
  position: absolute;
  top: 78px;
  left: -2px;
  text-align: center;
  height: 23px;
  border-radius: 3px;
  width: 16px;
  border: 1px solid grey;
}
.wrap {
  min-height: 45px;
}
.fa-copy {
  position: absolute;
  z-index: 9999;
}

.pm-job {
  background-color: #fefbf2 !important;
  border: 1px solid #ffab00 !important;
}

@media only screen and (min-width: 1024px) {
  .job-trucks-movers {
    padding-left: 22px;
  }
}
@media only screen and (max-width: 1024px) {
  .contact-info-wrapper {
    display: none !important;
  }
  .cluster-user-username {
    display: none !important;
  }
  .job-customer {
    padding-left: 0 !important;
  }
  .laptop-hidden {
    display: none !important;
  }
}

@media only screen and (max-width: 1000px) {
  .responsive-handle {
    display: none !important;
  }
}
@media only screen and (max-width: 490px) {
  .list-box-header-right {
    padding-left: 0 !important;
  }
  .list-box-header {
    justify-content: flex-start;
  }
  .price {
    margin-right: 13px;
  }
  .hidden-mobile {
    display: none !important;
  }
  .mobile-padding-reset {
    padding: 0 0 0 1rem;
  }
}
@media only screen and (max-width: 414px) {
  .mobile-padding-reset {
    margin: 0 !important;
  }
  .movers-number {
    padding-right: 0 !important;
  }
  .list-box-header-right {
    padding-right: 0 !important;
  }
  .dropdown .add-filter {
    margin-left: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/JobsBlock.vue